import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { http } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) { navigate("/login", { replace: true }); return; }
    (async () => {
      try {
        const { data } = await http.post("/auth/google/session", { session_id: sessionId });
        if (data.token) localStorage.setItem("kt_token", data.token);
        await checkAuth();
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      } catch (e) {
        navigate("/login", { replace: true });
      }
    })();
  }, [location, navigate, checkAuth]);

  return <div className="min-h-screen flex items-center justify-center text-slate-500">Menghubungkan akun Google…</div>;
}
